import { render, staticRenderFns } from "./PortalFooter.vue?vue&type=template&id=c6592c3c&"
import script from "./PortalFooter.vue?vue&type=script&lang=js&"
export * from "./PortalFooter.vue?vue&type=script&lang=js&"
import style0 from "./PortalFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports